import React from 'react';
import { withRouter } from 'react-router-dom';
import AboutSamfunnsDialogScreen from '../components/AboutSamfunnsDialogScreen';

const AboutSamfunnsDialogView = (props) => {
    return <AboutSamfunnsDialogScreen onClose={() => props.history.goBack()} />
};

export default withRouter(AboutSamfunnsDialogView);